<template>  
  <b-button 
    size="sm" 
    variant="secondary" 
    v-b-tooltip.hover 
    :title="showToolTip ? toolTip : ''" 
    @click="$emit('click', state)"
  >
    <i :class="state ? 'fa fa-check-square' : 'fa fa-minus-square-o'"></i>
  </b-button>
</template>

<script>

export default ({
  name: "button-check",

  props: {
    value: {
      type: Boolean,
      default: false
    },

    textCheck: {
      type: String,
      default: 'Выдать в работу'
    },

    textUncheck: {
      type: String,
      default: 'Отменить'
    }
  },

  data: () => {
    return {
      
    }
  },

  computed: {
    state: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },

    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    },

    toolTip() {
      return this.state ? this.textUncheck : this.textCheck
    }
  },

  methods: {
    
  }
})
</script>
